import { useMutationWithResultNotification } from '../useMutationWithResultNotification';
import { IPatchObject } from '../../../interfaces/request';
import {
  displayErrorNotification,
  displaySuccessNotification,
} from '../../../modules/Notifications';
import { editCaseCategory } from '../../caseCategories';
import { IMutationProps } from '../../../interfaces/ui';

type usePatchCaseCategoryParams = {
  organizationId: string;
  categoryId: string;
};

const usePatchCaseCategory = (
  params: usePatchCaseCategoryParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification<IPatchObject[], void>({
    asyncApiFunction: async (patchData) => {
      await editCaseCategory(
        params.organizationId,
        params.categoryId,
        patchData
      );
    },
    resetOnResult: true,
    onError: () => {
      displayErrorNotification('MyOrganizations.caseCategories.patchFailure');
    },
    onSuccess: () => {
      if (options.successFb) options.successFb();

      displaySuccessNotification('MyOrganizations.caseCategories.patchSuccess');
    },
  });
};

export default usePatchCaseCategory;
